var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h4',[_vm._v("Page not found")]),_c('h6',[_vm._v("Error 404")])])}
var staticRenderFns = []

export { render, staticRenderFns }